import { Component, Injector, OnInit } from '@angular/core';
import { BasePermissionService } from 'tnx-admin-service/authorization/basepermission/services';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import { ButtonPermission, CheckBoxListControlSchema, ComponentContextService, DataFormBase, DropdownControlSchema, EventData, FormSchemaBase, getMenuData, LabelSchema, EnvironmentService, RadioButtonListControlSchema } from 'tnx-shared';

export enum ImportQuyenType {
    API = 1,
    CLIENT = 2
}

@Component({
    selector: 'app-basepermission-import-form',
    templateUrl: './basepermission-import-form.component.html',
    styleUrls: ['./basepermission-import-form.component.scss'],
    providers: [ComponentContextService]
})
export class BasepermissionImportFormComponent extends DataFormBase implements OnInit {

    constructor(
        _injector: Injector,
        private _basePermissionService: BasePermissionService,
        private _moduleService: ModuleService,
        private _environmentService: EnvironmentService
    ) {
        super(_injector);
    }


    arrType = [];
    type: any;
    file: any;
    services = [];
    isSubmitting = false;

    lstButtonPermissions: string[] = [];
    lstButtonPermissionSelected: string[] = [];
    onlyImportButtonPermission = false;
    buttonPermissionDataSource: {ten: string, id: string}[] = [];
    endpointDataSource: {ten: string, id: string}[] = [];

    private static generateButtonPermissionName(permission: string, controllerName: string) {
        let permissionName = '';
        switch (permission) {
            case ButtonPermission.BUTTON_PHAN_QUYEN:
                permissionName = `Quyền cho button phân quyền của`;
                break;
            case ButtonPermission.BUTTON_CAU_HINH_QUY_TRINH:
                permissionName = `Quyền cho button cấu hình quy trình`;
                break;
        }
        return `${permissionName} ${controllerName}`;
    }

    private static generateName(data, route): string {
        if (data.Method == 'GET' && data.EndPoint == data.ControllerName) {
            return `${data.ControllerName} - Lấy danh sách bản ghi`;

        }
        else if (data.Method == 'POST' && data.EndPoint == data.ControllerName) {
            return `${data.ControllerName} - Thêm mới bản ghi`;

        }
        else if (data.Method == 'GET' && data.EndPoint == `${data.ControllerName}/{id}`) {
            return `${data.ControllerName} - Xem chi tiết bản ghi`;

        }
        else if (data.Method == 'PUT' && data.EndPoint == `${data.ControllerName}/{id}`) {
            return `${data.ControllerName} - Sửa bản ghi`;

        }
        else if (data.Method == 'DELETE' && data.EndPoint == `${data.ControllerName}/{id}`) {
            return `${data.ControllerName} - Xóa bản ghi`;

        }
        else if (data.Method == 'GET' && data.EndPoint == `${data.ControllerName}/CheckExist/{keyToCheck}`) {
            return `${data.ControllerName} - Kiểm tra tồn tại`;

        }
        else if (data.Method == 'DELETE' && data.EndPoint == `${data.ControllerName}/DeleteMany/{ids}`) {
            return `${data.ControllerName} - Xóa danh sách bản ghi`;
        }
        else {
            return route;
        }
    }

    ngOnInit() {
        this.setupVariabes();
        this.setting.baseService = this._basePermissionService;
        this.setting.schema = <FormSchemaBase[]>[
            new LabelSchema({
                showLabel: false,
                text: this._translateService.instant('Import quyền'),
                mdWidth: 4
            }),
            new RadioButtonListControlSchema({
                field: 'type',
                dataSource: this.arrType,
                showLabel: false,
                mdWidth: 8,
                onChanged: (evt: EventData) => {
                    evt.formControls['serviceEndpoint'].hidden = !(this.model.data.type == ImportQuyenType.API);
                    evt.formControls['label_serviceEndpoint'].hidden = !(this.model.data.type == ImportQuyenType.API);
                }
            }),
            new LabelSchema({
                field: 'onlyButtonPermission_label',
                for: 'onlyButtonPermission',
                text: 'Chỉ import quyền của button',
                showLabel: false,
                mdWidth: 4,
            }),
            new CheckBoxListControlSchema({
                field: 'onlyButtonPermission',
                showLabel: false,
                mdWidth: 8,
                dataSource: [
                    { value: true, label: '' }
                ],
                onChanged: (evt: EventData) => {
                    if (evt.eventType == 'change')
                        this.onlyImportButtonPermission = !this.onlyImportButtonPermission;
                    console.log(this.onlyImportButtonPermission);
                },
                hiddenCheck: () => this.model.data.type != ImportQuyenType.API,
            }),
            new DropdownControlSchema({
                field: 'buttonPermission',
                showLabel: false,
                mdWidth: 12,
                multiple: true,
                dataSource: this.buttonPermissionDataSource,
                onChanged: async (evt: EventData) => {
                    this.lstButtonPermissionSelected = evt.model.map(x => x.id);
                    console.log(this.lstButtonPermissionSelected);
                },
                hiddenCheck: () => !this.onlyImportButtonPermission
            }),
            new LabelSchema({
                field: 'label_serviceEndpoint',
                showLabel: false,
                text: this._translateService.instant('Ứng dụng'),
                mdWidth: 4
            }),
            new DropdownControlSchema({
                field: 'serviceEndpoint',
                // baseService: this._moduleService,
                dataSource: this.endpointDataSource,
                filter: true,
                showClear: true,
                showLabel: false,
                mdWidth: 8,
                loadOnInit: true
            }),
        ];
        super.ngOnInit();
    }

    private setupVariabes() {
        this.model.data.type = ImportQuyenType.API;
        this.lstButtonPermissions = this._environmentService.getListAppCode();
        for (const buttonPermission of this.lstButtonPermissions) {
            this.buttonPermissionDataSource.push({
                ten: buttonPermission,
                id: buttonPermission
            });
        }
        const apiDomain = this._environmentService.getListApiDomain();
        for (const domainName in apiDomain) {
            if (domainName.startsWith('-') || domainName.startsWith('1') || domainName == 'gateway')
                continue;
            const realDomainName = domainName.split('Endpoint') ? domainName.split('Endpoint')[0] : domainName;
            this.endpointDataSource.push({
                id: realDomainName,
                ten: realDomainName
            });
        }

        this.arrType = [
            { ten: 'API', id: ImportQuyenType.API },
            { ten: 'Client', id: ImportQuyenType.CLIENT }
        ];
    }

    async onFormInitialized(formEvent: EventData) {
    }

    async importButtonPermission() {
        if (!this.model.data.serviceEndpoint) {
            return this._notifierService.showWarning('Bạn chưa chọn phân hệ');
        }

        this.isSubmitting = true;
        const response = await this._basePermissionService.getPermissionFromService(this.model.data.serviceEndpoint, true);
        const permissionsToInsert = [];
        const controllerMap = new Map<string, number>();
        for (const element of response) {
            const route = `${this.model.data.serviceEndpoint}/${element.EndPoint}/${element.Method}`.toUpperCase();
            if (!controllerMap.get(element.ControllerName)) {
                controllerMap.set(element.ControllerName, 1);
                for (const permission of this.lstButtonPermissions) {
                    permissionsToInsert.push({
                        orderNo: 1,
                        code: `${this.model.data.serviceEndpoint}/${element.ControllerName}/${permission}`.toUpperCase(),
                        description: `Quyền của button ${permission}`,
                        name: BasepermissionImportFormComponent.generateButtonPermissionName(permission, element.ControllerName),
                        controller: element.ControllerName,
                        route,
                        moduleCode: this.model.data.serviceEndpoint,
                    });
                }
            }
        }

        console.log(permissionsToInsert);
        this._basePermissionService.import(permissionsToInsert).then(importRes => {
            if (!importRes.success) {
                this._notifierService.showBusinessError('Có vấn đề trong lúc import quyền cho api');
            }
            this._notifierService.showInsertDataSuccess();
            this.onSaved.emit();
        });
        this.isSubmitting = false;
    }

    import() {
        if (this.model.data.type == ImportQuyenType.API) {
            if (this.onlyImportButtonPermission)
                this.importButtonPermission();
            else
                this.importServiceEndpoint();
        }
        else if (this.model.data.type == ImportQuyenType.CLIENT) {
            this.importClientEndpoint();
        }
    }

    async importClientEndpoint() {
        this.isSubmitting = true;

        // Lấy thông tin các phân hệ đc cấu hình trong file application.json
        // Điều kiện: Mỗi phân hệ phải cấu hình tên file json chứa menu
        const lstAppSwitchers = this._environmentService.getListApp();
        const menuNames = this._environmentService.getListAppCode();
        // let err = [];
        lstAppSwitchers.forEach(app => {
            // if (!app.fileMenu) {
            //     err.push(`${app.code}`);
            //     return;
            // }
            menuNames.push(`${app.code.toLowerCase()}`);
        });

        // if (err.length > 0) {
        //     return this._notifierService.showWarning(`Chưa cấu hình tên menu cho phân hệ ${err.toString()}`);
        // }

        const menuDatas = getMenuData(menuNames);

        const permissions = [];
        lstAppSwitchers.forEach((app) => {
            const appCode = app.code.toString().toUpperCase();
            const menu = menuDatas.find(x => x.fileName == appCode.toLowerCase());
            permissions.push({
                orderNo: 1,
                code: `${appCode}.MODULE.${appCode}`.toUpperCase(),
                name: `Phân hệ ${app.title}`,
                description: `Phân hệ ${app.title}`,
                endpoint: `${appCode}.MODULE.${appCode}`.toUpperCase(),
                moduleCode: appCode,
                controller: appCode
            });
            if (menu) {
                menu.dataMenus.forEach(item => {
                    this.pushPermission(`[${appCode}]`, `${appCode}`, item, permissions, 1);
                });
            }
        });

        const importRs = await this._basePermissionService.import(permissions);
        this.isSubmitting = false;
        if (importRs.success) {
            this._notifierService.showInsertDataSuccess();
            this.onSaved.emit();
        }
    }

    pushPermission(prefix, moduleCode, menuItem, permissions, deepLevel) {
        if (menuItem.isRootMenu) {
            return;
        }

        let name = '';
        if (deepLevel == 1) {
            name = `${prefix} ${menuItem.label}`;
        }
        else {
            name = `${prefix} > ${menuItem.label}`;
        }


        if (menuItem.items) {
            menuItem.items.forEach(x => this.pushPermission(name, moduleCode, x, permissions, ++deepLevel));
        }
        else {
            permissions.push({
                orderNo: 1,
                code: `${moduleCode}${menuItem.routerLink}`.toUpperCase(),
                name,
                description: name,
                endpoint: `${moduleCode}${menuItem.routerLink}`.toUpperCase(),
                moduleCode,
                controller: moduleCode
            });
        }
    }

    async importServiceEndpoint() {
        if (!this.model.data.serviceEndpoint) {
            return this._notifierService.showWarning('Bạn chưa chọn ứng dụng');
        }

        this.isSubmitting = true;
        const response = await this._basePermissionService.getPermissionFromService(this.model.data.serviceEndpoint, false);
        const permissions = [];
        const controllerMap = new Map<string, number>();
        response.forEach(element => {
            const route = `${this.model.data.serviceEndpoint}/${element.EndPoint}/${element.Method}`.toUpperCase();
            if (!controllerMap.get(element.ControllerName)) {
                controllerMap.set(element.ControllerName, 1);
                for (const permission of this.lstButtonPermissions) {
                    permissions.push({
                        orderNo: 1,
                        code: `${this.model.data.serviceEndpoint}/${element.ControllerName}/${permission}`.toUpperCase(),
                        description: `Permission của button ${permission}`,
                        name: BasepermissionImportFormComponent.generateButtonPermissionName(permission, element.ControllerName),
                        controller: element.ControllerName,
                        route: '',
                        moduleCode: this.model.data.serviceEndpoint,
                    });
                }
            }
            permissions.push({
                orderNo: 1,
                code: route,
                name: element.Description === null ? BasepermissionImportFormComponent.generateName(element, route) : `${element.ControllerName} - ${element.Description}`,
                description: element.Description === null ? '' : element.Description,
                endpoint: route,
                moduleCode: this.model.data.serviceEndpoint,
                controller: element.ControllerName
            });
        });

        const importRs = await this._basePermissionService.import(permissions);
        this.isSubmitting = false;
        if (importRs.success) {
            this._notifierService.showInsertDataSuccess();
            this.onSaved.emit();
        }
    }

}
